import { render } from "./EmployeePerformanceSelf.vue?vue&type=template&id=72665ff6&scoped=true"
import script from "./EmployeePerformanceSelf.vue?vue&type=script&lang=js"
export * from "./EmployeePerformanceSelf.vue?vue&type=script&lang=js"

import "./EmployeePerformanceSelf.vue?vue&type=style&index=0&id=72665ff6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72665ff6"]])

export default __exports__